import CloseButton from 'components/ResponsiveModal/CloseButton/styled';

export default CloseButton;
